import { defineStore } from 'pinia'
import { ref } from 'vue'

export const tpsSamples = 5

export const useClusterStore = defineStore('cluster', () => {
  const tps = ref()
  const tpsLoading = ref(true)

  return {
    tps,
    tpsLoading,
  }
})
